module.exports = __webpack_public_path__ + "img/tss-10.fd724813.jpg";